/* unplugin-vue-components disabled */import script from "./JwtPage.vue?vue&type=script&setup=true&lang=js"
export * from "./JwtPage.vue?vue&type=script&setup=true&lang=js"

import "./JwtPage.vue?vue&type=style&index=0&id=25da307a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25da307a"]])

export default __exports__